import AdvancedFiltersModalView from './advanced_filters_modal_view';

export default AdvancedFiltersModalView.extend({
  bindings: {
    '.js-provider-group-checkbox': 'provider_group',
  },

  initialize(options) {
    AdvancedFiltersModalView.prototype.initialize.call(this, options);
    this.stickit();
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/search/provider_groups_modal_view.js